module.exports = __webpack_public_path__ + "img/none@2x.31308858.png";